<!--
  We’re using a custom skeleton here instead of <v-skeleton-loader>
  because Vuetify doesn’t provide the types needed to match the design specs
-->
<template>
  <div class="DocumentSearchPageLoader">
    <div
      v-for="n in 10"
      :key="n"
      class="DocumentSearchPageLoader__item"
    >
      <div class="skeleton-file-icon" />
      <div class="skeleton-content">
        <div class="skeleton-line long mb-3" />
        <div class="skeleton-meta">
          <div class="skeleton-line short" />
          <div class="skeleton-line short" />
          <div class="skeleton-line short" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
$loader-gradient: linear-gradient(90deg, #F1F2F3 46.5%, #FAFAFA 100%);

.DocumentSearchPageLoader {
  .DocumentSearchPageLoader__item {
    background: white;
    display: flex;
    align-items: flex-start;
    padding: 16px;
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid rgb(var(--v-theme-grey-lighten-4));
  }

  .skeleton-file-icon {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    margin-right: 12px;
    background: $loader-gradient;
  }

  .skeleton-content {
    flex: .6;
  }

  .skeleton-meta {
    display: flex;
    gap: 8px;
  }

  .skeleton-line {
    border-radius: 4px;
    background: $loader-gradient;

    &.long {
      height: 16px;
      width: 80%;
    }

    &.short {
      height: 12px;
      width: 20%;
      margin-right: 8px;
    }
  }
}
</style>
